import { z } from 'zod';

export function isBeforeMinDate(passedDate: Date | null, minDate?: Date): boolean {
  if (passedDate === null || typeof minDate === 'undefined') {
    return false;
  }

  return passedDate < minDate;
}

// Do not use `if(date === null)` because the MUI DatePicker can return an "Invalid Date" object which is of type Date
export function isNull(potentiallyInvalidDatePickerDate: Date | null): potentiallyInvalidDatePickerDate is null {
  return !z.date().safeParse(potentiallyInvalidDatePickerDate).success;
}
